const vowels: { [letter: string]: boolean } = {
  a: true,
  e: true,
  i: true,
  o: true,
  u: true,
};

const prefixWithArticle = (word: string) => {
  if (vowels[word[0].toLowerCase()]) {
    return 'an ' + word;
  } else {
    return 'a ' + word;
  }
};

export default prefixWithArticle;
